import { render, staticRenderFns } from "./DashboardWidgetUserStatus.vue?vue&type=template&id=0905359e&scoped=true"
import script from "./DashboardWidgetUserStatus.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetUserStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0905359e",
  null
  
)

export default component.exports